export default "__VITE_ASSET__35833cdd__"